module.exports = __webpack_public_path__ + "img/it.7a02c835.png";